<div id="logo" fxLayout="row" routerLink="/" fxFlexAlign="space-around center">
  <span class="logo-image"
    ><img src="../../../../assets/preneed/logo.svg" #appLogoImage alt="Ziraxi Logo"
  /></span>
</div>
